import React, { useState, useEffect } from 'react'
import {
  Table,
  ButtonGroup,
  IconButton,
  Icon,
  ControlLabel,
  Grid,
  Form,
  Row,
  Col,
  ButtonToolbar,
  Message,
  Input,
  Modal,
  Button,
} from 'rsuite'
import {
  isRequired,
  isValidators,
  requiredFiled,
  getMaxLengthData,
} from '../../../utils/ValidatorUtils'
import CustomAlertMessageInfo from '../../../widgets/CustomAlertMessageInfo'
import ErrorMessage from '../../message/errorMessage/ErrorMessage'
import ShowLimitLength from '../../utils/ShowLimitLength'
import HTMLWidget from '../../../widgets/HTMLWidget'

export default function InputDataTableForm({
  schema: _schema,
  // dataList: _dataList,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  onSubmit,
  onDelete,
  ...props
}) {
  const { Column, HeaderCell, Cell } = Table

  const { isDeleteError, isError, loading } = props
  const [schema, setSchema] = useState({})
  const [selectedIndex, setSelectedIndex] = useState(-1)
  const [inputValue, setInputValue] = useState('')
  const [isAdd, setIsAdd] = useState(false)
  const [isdelete, setIsdelete] = useState(false)
  const [isDeleteFail, setIsDeleteFail] = useState(false)
  const [isSaveError, setIsSaveError] = useState(false)
  const [textLength, setTextLength] = useState(0)

  useEffect(() => {
    setIsAdd(isError)
    setIsSaveError(isError)
    setIsDeleteFail(isDeleteError)
    setSchema(_schema)
  }, [_schema])

  useEffect(() => {
    setIsSaveError(isError)
    setIsAdd(isError)
  }, [isError])

  useEffect(() => {
    setIsDeleteFail(isDeleteError)
  }, [isDeleteError])

  const handleEdit = (rowData, index) => {
    setSelectedIndex(index)
    setInputValue(rowData.value)
    setValue(schema.name, rowData.value)
    setIsDeleteFail(false)
    setIsAdd(true)
    setTextLength(rowData.value.length)
  }

  const onAdd = () => {
    setSelectedIndex(-1)
    setInputValue('')
    setIsAdd(true)
    setIsDeleteFail(false)
    setTextLength(0)
  }

  const onChangeText = (txt) => {
    setTextLength(txt.length)
  }

  return (
    <>
      {schema.description && <CustomAlertMessageInfo contents={schema.description} />}

      {isAdd && (
        <div>
          {schema.message &&
            schema.message.map((item) => {
              return (
                <Message showIcon type={item.type} description={item.description} key={item.type} />
              )
            })}

          <br />

          {schema.msg?.map((item) => {
            return (
              <Message
                style={{ marginBottom: 10 }}
                showIcon={item.showIcon}
                type={item.type}
                description={<HTMLWidget data={item.message} />}
              />
            )
          })}

          <ErrorMessage error={errors[schema.name]} />
          <Grid fluid>
            <Form fluid>
              <Controller
                key="selectedIndex"
                name="selectedIndex"
                control={control}
                defaultValue={selectedIndex}
              />

              <Row>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <ControlLabel>{requiredFiled(schema.validators, schema.label)}</ControlLabel>
                  <Controller
                    key="selectedIndex"
                    name="selectedIndex"
                    control={control}
                    defaultValue={selectedIndex}
                  />

                  {getMaxLengthData(schema?.validators)?.value > 0 ? (
                    <>
                      <Input
                        placement="auto"
                        name={schema.name}
                        defaultValue={inputValue}
                        placeholder={schema.hint || `ระบุ${schema.label}`}
                        inputRef={register(isValidators(schema.validators))}
                        maxLength={getMaxLengthData(schema?.validators)?.value}
                        onChange={(text) => onChangeText(text)}
                      />
                      <ShowLimitLength
                        textLength={textLength}
                        maxLength={getMaxLengthData(schema?.validators)?.value}
                      />
                    </>
                  ) : (
                    <Input
                      placement="auto"
                      name={schema.name}
                      defaultValue={inputValue}
                      placeholder={schema.hint || `ระบุ${schema.label}`}
                      inputRef={register(isValidators(schema.validators))}
                    />
                  )}
                </Col>
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                  {isSaveError && (
                    <Row style={{ marginBottom: 10 }}>
                      <Message
                        showIcon
                        type="error"
                        description={`บันทึก ${
                          schema.buttonText ? schema.buttonText : ''
                        } ไม่สำเร็จ`}
                      />
                    </Row>
                  )}
                  <ButtonToolbar>
                    <div>
                      <IconButton
                        style={{ marginRight: 10 }}
                        appearance="ghost"
                        className={selectedIndex === -1 ? '' : 'rs-btn-ghost-edit'}
                        icon={
                          <Icon
                            icon={selectedIndex === -1 ? 'save' : 'edit'}
                            className={
                              selectedIndex === -1
                                ? 'bt-gost-icon-radius'
                                : 'bt-gost-icon-radius-edit '
                            }
                          />
                        }
                        onClick={onSubmit}
                        disabled={loading}
                      >
                        {selectedIndex === -1 ? 'บันทึก' : 'แก้ไข'}
                        {schema.buttonText ? schema.buttonText : ''}
                      </IconButton>

                      <IconButton
                        appearance="ghost"
                        className="rs-btn-ghost-cancel"
                        style={{ marginRight: 10 }}
                        icon={<Icon icon="close" className="bt-gost-icon-radius-cancel" />}
                        onClick={(e) => {
                          setIsSaveError(false)
                          setIsDeleteFail(false)
                          setIsAdd(false)
                          setTextLength(0)
                        }}
                        disabled={loading}
                      >
                        ยกเลิก
                      </IconButton>
                    </div>
                  </ButtonToolbar>
                </Col>
              </Row>
            </Form>
          </Grid>
        </div>
      )}

      {!isAdd && (
        <Row style={{ marginTop: '10px' }}>
          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
            <div>
              <IconButton
                appearance="ghost"
                icon={<Icon icon="plus" className="bt-gost-icon-radius" />}
                onClick={onAdd}
                style={{ marginRight: 5 }}
                disabled={loading}
              >
                {'เพิ่ม'}
                {schema.buttonText ? schema.buttonText : ''}
              </IconButton>
            </div>
          </Col>
        </Row>
      )}

      {isDeleteFail && (
        <Message
          showIcon
          type="error"
          description={`ลบ ${schema.buttonText ? schema.buttonText : ''} ไม่สำเร็จ`}
        />
      )}
      <Table height={300} wordWrap data={schema.value} style={{ marginTop: 10 }}>
        <Column width={70} align="center" fixed>
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>

        <Column flexGrow={1} fixed>
          <HeaderCell>{schema.label}</HeaderCell>
          <Cell>
            {(rowData) => {
              // return rowData.value
              return <div dangerouslySetInnerHTML={{ __html: rowData.value }} />
            }}
          </Cell>
        </Column>

        <Column width={200} align="center" fixed="right" verticalAlign="middle">
          <HeaderCell></HeaderCell>

          <Cell>
            {(rowData, index) => {
              return (
                <div>
                  <ButtonGroup>
                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-edit"
                      icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                      onClick={() => handleEdit(rowData, index)}
                    >
                      แก้ไข
                    </IconButton>

                    <IconButton
                      appearance="ghost"
                      className="rs-btn-ghost-cancel"
                      icon={<Icon icon="trash-o" className="bt-gost-icon-none-radius-cancel" />}
                      onClick={() => {
                        setSelectedIndex(index)
                        setIsdelete(true)
                      }}
                      disabled={
                        typeof rowData.isDeleteable !== 'undefined'
                          ? !rowData.isDeleteable
                          : rowData.isDisabled
                      }
                    >
                      ลบ
                    </IconButton>
                  </ButtonGroup>
                </div>
              )
            }}
          </Cell>
        </Column>
      </Table>

      <Modal
        backdrop="static"
        size="xs"
        show={isdelete}
        onHide={(e) => {
          setIsdelete(false)
          setIsDeleteFail(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>ยืนยันการลบ</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {isdelete && `ยืนยันการลบ ${schema.buttonText ? schema.buttonText : ''}`}
          {/* {isDeleteFail && (
            <Message
              showIcon
              type="error"
              description={`ลบ ${schema.buttonText ? schema.buttonText : ''} ไม่สำเร็จ`}
            />
          )} */}
        </Modal.Body>
        <Modal.Footer>
          {isdelete && (
            <>
              <Button
                onClick={(e) => {
                  onDelete(selectedIndex)
                  setIsdelete(false)
                  setIsDeleteFail(false)
                }}
                appearance="primary"
              >
                ลบ
              </Button>
              <Button
                onClick={(e) => {
                  setIsdelete(false)
                  setIsDeleteFail(false)
                  setSelectedIndex(-1)
                }}
                appearance="subtle"
              >
                ยกเลิก
              </Button>
            </>
          )}

          {/* {isDeleteFail && (
            <Button
              onClick={(e) => {
                setIsDeleteFail(false)
                setIsdelete(false)
                setSelectedIndex(-1)
              }}
              appearance="subtle"
            >
              ปิด
            </Button>
          )} */}
        </Modal.Footer>
      </Modal>
    </>
  )
}
